import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileInfo"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 1.50025C15.1995 1.49489 15.3913 1.5771 15.525 1.72525L20.775 6.97525C20.9231 7.10894 21.0054 7.30077 21 7.50025V21.0002C21 21.8287 20.3284 22.5002 19.5 22.5002H13.5V21.0003H19.5V9.00027H15C14.1716 9.00027 13.5 8.32869 13.5 7.50027V3.00027H7.5V4.46529V9.00027H6V3.00025C6 2.17182 6.67157 1.50025 7.5 1.50025H15ZM19.2 7.50023L15 3.30023V7.50023H19.2ZM3 16.5003C3 13.5753 5.325 11.2503 8.25 11.2503C11.175 11.2503 13.5 13.5753 13.5 16.5003C13.5 19.4253 11.175 21.7503 8.25 21.7503C5.325 21.7503 3 19.4253 3 16.5003ZM8.84996 13.7253C8.84996 13.3503 8.54996 13.1253 8.24996 13.1253C7.94996 13.1253 7.64996 13.2753 7.64996 13.6503C7.64996 14.0253 7.94996 14.2503 8.24996 14.2503C8.54996 14.2503 8.84996 14.1003 8.84996 13.7253ZM6.75 18.7503V19.5753H9.75V18.6753H8.7V15.3003H7.125V16.2003H7.8V18.7503H6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.84996 13.7252C8.84996 13.3502 8.54996 13.1252 8.24996 13.1252C7.94996 13.1252 7.64996 13.2752 7.64996 13.6502C7.64996 14.0252 7.94996 14.2502 8.24996 14.2502C8.54996 14.2502 8.84996 14.1002 8.84996 13.7252ZM6.75 19.5753H9.75V18.6753H8.7V15.3003H7.125V16.2003H7.8V18.7503H6.75V19.5753Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileInfo.vue"]]);
